export enum ToolbarPositions {
  TopLeft = 'TopLeft',
  TopRight = 'TopRight',
  CenterLeft = 'CenterLeft',
  CenterRight = 'CenterRight',
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
}
